// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c50d6347","389":"c3cd2fa2","453":"60127a42","455":"b2b10dd5","857":"07dcfac5","977":"5f5b00b0"}[chunkId] + ".chunk.js";
};